import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import firebase from "firebase/compat/app";

// Version du front. À incrémenter quand les onglets ouverts doivent être rechargés (ex. passage
// des règles Firestore en R2, tampon d'audit obligatoire), puis poser config/app.min_build à
// cette valeur (console Firebase ou Admin SDK) : les onglets plus anciens affichent ce message.
export const APP_BUILD = 20261006;

export default function VersionGuard() {
  const [outdated, setOutdated] = useState(false);

  useEffect(() => {
    const unsubscribe = firebase
      .firestore()
      .collection("config")
      .doc("app")
      .onSnapshot(
        (snap) => {
          const minBuild = snap.exists ? Number(snap.data().min_build) || 0 : 0;
          setOutdated(APP_BUILD < minBuild);
        },
        () => setOutdated(false)
      );
    return unsubscribe;
  }, []);

  return (
    <Modal
      visible={outdated}
      title="Nouvelle version disponible"
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={[
        <Button key="reload" type="primary" onClick={() => window.location.reload()}>
          Recharger
        </Button>,
      ]}
    >
      Une nouvelle version de Solidoc est en ligne. Rechargez la page pour continuer : les
      modifications non enregistrées seront perdues.
    </Modal>
  );
}
